import { Field, Formik } from "formik"
import { useEffect, useState } from "react";
import { Alert, Button, Card, Col, Form, Row } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import * as Yup from 'yup';
import Get from "../../api/Get";
import Post from "../../api/Post";
import { TIPO_DOCUMENTO_PACIENTE_COLOMBIA, VALIDATE_NUEVA_EPS } from "../../api/Routes";
import LoadingList from "../../loader/LoadingList";
import { getTokenExternal } from "../../utils/getTokenExternal";

function StepEPSOnly({t}){
    const [idTipoDocumento, setIdTipoDocumento] = useState(null) 
    const [hasLength, setHasLength] = useState(10)
    const [tipoDocumentoOpt, setTipoDocumentoOpt] = useState([])
    const [initialData, setInitialData] = useState({
        identityDocumentType: '',
        documentNumber: ''
    });
    const [error, setError] = useState({
        error: false,
        msg: ''
    })

    const getLengthDN = (code) =>{
        switch(code.toUpperCase()){            
            case 'CE':
                return 6
            case 'CD':
            case 'PA':
            case 'SC':
                return 16
            case 'PE':
                return 15
            case 'RC':
            case 'TI':
                return 11
            case 'CN':
                return 9
            case 'MS':
                return 12
            default:
                return 10;
        }
    }
    const getTipoDocumento = (value) =>{
        let arr = tipoDocumentoOpt.filter(el=>el.code==="AS" || el.code==="MS").map(e=>(e.id))
        return arr.includes(parseInt(value))
    }

    const shemaValidateStepOne = Yup.object().shape({
        identityDocumentType: Yup.string()
           .required(t('Camporequerido')),
           documentNumber: Yup.string()
           .when('identityDocumentType', {
               is: value => getTipoDocumento(value),
               then: Yup.string().required(t('Camporequerido')),
               otherwise: Yup.string()
               .required(t('Camporequerido'))
               .min(5, `Debe tener una longitud mínima de 5 caracteres`)
               .max(hasLength, `Debe tener una longitud máxima de ${hasLength} caracteres`),
           }),
    })

    useEffect(() => {
        Get({url: TIPO_DOCUMENTO_PACIENTE_COLOMBIA, noToken: true})
        .then(response=>{
            setTipoDocumentoOpt(response.data)
        })
        .catch(error=>{
            setTipoDocumentoOpt([])
        })
    }, [])

    return (
        <Formik
            initialValues={initialData}
            validationSchema={shemaValidateStepOne}
            onSubmit={async (values, { setSubmitting,setFieldValue }) => {
                console.log(values)
                const data = {
                    documentNumber: values.documentNumber,
                    identityDocumentType: {
                        id: values.identityDocumentType
                    }
                }                
                let response = await getTokenExternal({id: 2})
                if(response.data.access_token){
                    const resp = await Post({url: VALIDATE_NUEVA_EPS, data: data, access_token: response.data.access_token, header: true})
                    console.log(resp)
                    if(resp.data.state){
                        setError({
                            error: false,
                            msg: ''
                        })
                    }else{
                        setError({
                            error: true,
                            msg: resp.data.error
                        })
                    }
                    setSubmitting(false)
                }

            }}            
        >{({
            values,
            errors,
            handleSubmit,
            setFieldValue,
            setFieldError,
            isSubmitting,
        })=>(
            <Form onSubmit={handleSubmit}>
                {isSubmitting && <LoadingList texto={'Buscando paciente'}/>}
                <Card className="mb-3">
                <Card.Header className="text-center bg-primary text-white">
                    <h5 className="m-0 text">Validar información</h5>                      
                </Card.Header>
                <Card.Body>
                <Row>
                    <Col xs="12" md="12">
                    <Form.Group>
                        <Form.Label className="font-weight-bold-600 text-secondary">{t('tipo_documento')} <span className="text-danger">*</span></Form.Label>
                        <Field 
                            as="select"
                            className={`form-control input-form ${errors.identityDocumentType && 'error'}`}
                            name="identityDocumentType"
                            onChange={e=>{
                                if(e.target.value!==""){
                                    setIdTipoDocumento(parseInt(e.target.value))
                                    setFieldValue("identityDocumentType", parseInt(e.target.value))
                                    setFieldValue("identityDocumentTypeModel", tipoDocumentoOpt.filter(el=>el.id===parseInt(e.target.value))[0])
                                    let aux = tipoDocumentoOpt.filter(el=>el.id===parseInt(e.target.value))[0]
                                    setHasLength(getLengthDN(aux.code))
                                }else{
                                    setIdTipoDocumento(null)
                                    setFieldValue("identityDocumentType", e.target.value)
                                    setFieldValue("identityDocumentTypeModel", "")                                  
                                }                                            
                            }}
                        >
                            <option value="">{t('Seleccionar')}</option>
                            {
                                tipoDocumentoOpt.map((item,i)=>(
                                    <option value={item.id} key={i}>{`${item.code} : ${item.name}`}</option>
                                ))
                            }
                        </Field>                                            
                        { errors.identityDocumentType && <div className="invalid-feedback d-block">{errors.identityDocumentType}</div> }                                    
                    </Form.Group>
                    </Col>
                    <Col xs="12" md="12">
                        <Form.Group>
                            <Form.Label className="font-weight-bold-600 text-secondary">{t('documento_identidad')} <span className="text-danger">*</span></Form.Label>
                            <Field 
                                type="text"
                                className={`form-control input-form ${errors.documentNumber && 'error'}`}
                                name="documentNumber"
                            />                                
                            { errors.documentNumber && <div className="invalid-feedback d-block">{errors.documentNumber}</div> }
                        </Form.Group>
                    </Col>
                    <Col xs="12" md="12">
                        <Button type="submit" variant="primary" className="btn1">Validar</Button>
                    </Col>
                </Row>
                </Card.Body>
                </Card>
                {error.error && <Row>
                    <Col xs="12" md="12">
                        <Alert variant="danger">
                            {error.msg.message}
                        </Alert>
                    </Col>
                </Row>}
            </Form>
        )}</Formik>
    )
}

export default withTranslation()(StepEPSOnly)